import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DsdLibraryModule } from '@dsd/library-angular/dist';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { FormComponent } from './components/form/form.component';
import { FormErrorMessageDirective } from './directives/form-error-message.directive';
import { FormErrorValidationContextDirective } from './directives/form-error-validation-context.directive';
import { InputConnectorDirective } from './directives/connectors/input-connector.directive';
import { RadioGroupConnectorDirective } from './directives/connectors/radio-group-connector.directive';
import { SelectConnectorDirective } from './directives/connectors/select-connector.directive';
import { RadioGroupValueAccessorDirective } from './directives/accessors/radio-group-value-accessor.directive';
import { RadioGroupChildDirective } from './directives/accessors/radio-group-child.directive';
import { InputComponent } from './components/input/input.component';
import { InputExtConnectorDirective } from './directives/connectors/input-ext-connector.directive';
import { FieldsetConnectorDirective } from './directives/connectors/fieldset-connector.directive';
import { FootnoteScreenReaderFixDirective } from './directives/footnote-screen-reader-fix.directive';
import { LinkDownloadFileNameDirective } from './directives/link-download-file-name.directive';

const DIRECTIVES = [
  FormErrorValidationContextDirective,
  FormErrorMessageDirective,
  InputConnectorDirective,
  InputExtConnectorDirective,
  SelectConnectorDirective,
  FieldsetConnectorDirective,
  RadioGroupConnectorDirective,
  RadioGroupChildDirective,
  RadioGroupValueAccessorDirective,
  FootnoteScreenReaderFixDirective,
  LinkDownloadFileNameDirective
];

const COMPONENTS = [FormComponent, InputComponent];

@NgModule({
  declarations: [...COMPONENTS, ...DIRECTIVES],
  exports: [...COMPONENTS, ...DIRECTIVES],
  imports: [CommonModule, DsdLibraryModule, FormsModule, ReactiveFormsModule, TranslateModule],
  providers: [DatePipe]
})
export class LibDsdExtensionModule {}
